import { ThemeProvider } from '@primer/react';
import { useEffect } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import BaseStyles from './BaseStyles';
import LoaderPage from './components/loader-page';
import AuthorizedContent from './content/AuthorizedContent';
import UnAuthorizedContent from './content/UnAuthorizedContent';
import { CommonProvider } from './contexts/common';
import { actions } from './state/actions/actionsWrapper';
import { RootState } from './state/reducers';
import { eAccountReducerStatus } from './state/reducers/authReducer';
import './style.css';
const queryClient = new QueryClient();
function App() {
  const { user_info, status } = useSelector((x: RootState) => x.auth)
  const dispath = useDispatch();
  useEffect(() => {
    if (localStorage.getItem("access_token")) {
      dispath(actions.account.getUserStart())
    }
  }, [])

  if (status === eAccountReducerStatus.is_getting_profile) {
    return <LoaderPage />
  }

  return (
    <Router>
      <ThemeProvider colorMode={"light"}>
        <BaseStyles>
          <QueryClientProvider client={queryClient}>
            <CommonProvider>
              {user_info && <AuthorizedContent />}
              {!user_info && <UnAuthorizedContent />}
            </CommonProvider>
          </QueryClientProvider>
        </BaseStyles>
      </ThemeProvider>
    </Router>
  );
}

export default App;
